import { render, staticRenderFns } from "./eventComp_mode_26.vue?vue&type=template&id=fdd6b3fe&scoped=true"
import script from "./eventComp_mode_26.vue?vue&type=script&lang=js"
export * from "./eventComp_mode_26.vue?vue&type=script&lang=js"
import style0 from "./eventComp_mode_26.vue?vue&type=style&index=0&id=fdd6b3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd6b3fe",
  null
  
)

export default component.exports